export default {
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'nav-icon icon-speedometer'
  }, {
    name: 'Objetivos',
    url: '/targets',
    icon: 'fa fa-table'
  }, {
    name: 'DIM',
    url: '/statistics/index',
    icon: 'fa fa-table'
  }, {
    name: 'Contas Correntes',
    url: '/accounts',
    icon: 'fa fa-list',
    auth: ['currentaccounts.access']
  }, {
    name: 'Visitas',
    url: '/visits',
    icon: 'fa fa-list',
    auth: ['visits.access']
  }, {
    name: 'Stocks',
    url: '/stocks',
    icon: 'fa fa-list',
    auth: ['stocks.access']
  }, {
    name: 'Equipamentos',
    url: '/equipment',
    icon: 'fa fa-list',
    auth: ['cabinets.access']
  }, {
    name: 'Promoções',
    url: '/promotions',
    icon: 'fa fa-list',
    auth: ['promotions.access']
  }, {
    name: 'SRAs',
    url: '/sra',
    icon: 'fa fa-list',
    auth: ['sra.access']
  }, {
    divider: true
  }, {
    name: 'Tabelas',
    url: '/tables',
    icon: 'icon-puzzle',
    auth: ['import.tables'],
    children: [
      {
        name: 'SKUs em falta',
        url: '/tables/missing-skus',
        icon: 'icon-puzzle'
      }, {
        name: 'Codles em falta',
        url: '/tables/missing-codles',
        icon: 'icon-puzzle'
      }, {
        name: 'Res. Importação',
        url: '/tables/import-batches',
        icon: 'icon-puzzle'
      }, {
        name: 'Obj. Contas',
        url: '/tables/settings',
        icon: 'icon-puzzle'
      }, {
        name: 'Produtos',
        url: '/tables/products',
        icon: 'fa fa-table'
      }, {
        name: 'Prod.Agregs',
        url: '/tables/prodaggregs',
        icon: 'fa fa-table'
      }, {
        name: 'Gamas',
        url: '/tables/mpg',
        icon: 'fa fa-table'
      }, {
        name: 'Marcas',
        url: '/tables/brands',
        icon: 'fa fa-table'
      }, {
        name: 'Cores',
        url: '/tables/cores',
        icon: 'fa fa-table'
      }, {
        name: 'Operadores',
        url: '/tables/clients',
        icon: 'fa fa-table'
      }, {
        name: 'Grupos Operadores',
        url: '/tables/operatorgroups',
        icon: 'fa fa-table'
      }, {
        name: 'Visibilidades',
        url: '/tables/visibilities',
        icon: 'fa fa-table'
      }, {
        name: 'Tipos Actividades',
        url: '/tables/activities',
        icon: 'fa fa-table'
      }, {
        name: 'Vendas',
        url: '/tables/sales',
        icon: 'fa fa-table'
      }]
  }, {
    divider: true
  }, {
    name: 'Utilizadores',
    url: '/users',
    icon: 'fa fa-users',
    auth: ['users.list']
  }, {
    name: 'Grupos',
    url: '/roles',
    icon: 'fa fa-users',
    auth: ['roles.list']
  }, {
    divider: true
  }]
}



// WEBPACK FOOTER //
// ./src/_nav.js